module.exports = __webpack_public_path__ + "8424c467167faaca2c16f437784a5498.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/pink-heart-glasses.png
// module id = 1864
// module chunks = 0